import DefaultElementNodeType from '../DefaultElementNodeType';
import {OTHER_LOCATION} from '../../metamodel/Concept';

export default class LocationNodeType extends DefaultElementNodeType {
	static get typeName() {
		return OTHER_LOCATION;
	}
}
